import type {ListSuppliersSearchInput} from "./list-suppliers.schema";

import {listSuppliers} from "@project/sdk/engineering";
import {ListSuppliersResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {supplierKeys} from "../../../supplier-keys";

import {listSuppliersSearchSchema} from "./list-suppliers.schema";

export function listSuppliersQueryOptions(rawInput: ListSuppliersSearchInput) {
  const params = listSuppliersSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: supplierKeys.list(params),
    queryFn: async ({signal}) => ListSuppliersResponse.parse(await listSuppliers(params, {signal})),
  });
}
